import { Controller } from "@hotwired/stimulus";

interface TomSelectLike {
  enable(): void;
  disable(): void;
}

// Shows the panels whose data-panel list contains the checked radio's value and
// hides (and disables the inputs of) the rest, so hidden fields neither block
// submission with `required` nor arrive in params.
//
//   <form data-controller="radio-panels">
//     <input type="radio" name="mode" value="a" data-action="change->radio-panels#update">
//     <div data-radio-panels-target="panel" data-panel="a b">…</div>
export default class extends Controller<HTMLElement> {
  static targets = ["panel"];

  declare readonly panelTargets: HTMLElement[];

  connect() {
    this.update();
  }

  update() {
    const checked = this.element.querySelector<HTMLInputElement>(
      'input[type="radio"]:checked',
    );
    const value = checked?.value ?? "";

    this.panelTargets.forEach((panel) => {
      const visible = (panel.dataset.panel ?? "").split(/\s+/).includes(value);
      panel.classList.toggle("hidden", !visible);
      panel
        .querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
          "input, select, textarea",
        )
        .forEach((field) => {
          field.disabled = !visible;
          // Tom Select draws its own control and mirrors `disabled` only when
          // told, so a field re-shown here stays greyed out and unclickable
          // unless the instance is switched too.
          const enhanced = (field as { tomselect?: TomSelectLike }).tomselect;
          if (!enhanced) return;

          if (visible) enhanced.enable();
          else enhanced.disable();
        });
    });
  }
}
